import React from 'react';
const Copyright = () => {
     return(
         <div className="c-copyright">
             <p className="text-sm">Copyright &copy; {new Date().getFullYear()}. All Rights Reserved.</p>
         </div>
     )
}

export default Copyright;